// import 'idempotent-babel-polyfill';
// import Vue from 'vue'
// import App from './js/App.vue'
// import router from './js/router.js';
// import './js/iframe_api'
import menuMfn from './js/fun/menuMfn'
import menuScroll from './js/fun/menuScroll'
import scrollHorizontal from './js/fun/scrollHorizontal'
// import setPeopleBoxWidth from './js/fun/setPeopleBoxWidth'
import inViewport from './js/fun/inViewport'
// import ytPlayerFn from './js/fun/ytPlayerFn'
import overlayFn from './js/fun/overlayFn'
import tabFn from './js/fun/tabFn'
import countAnimationGroup from './js/fun/countAnimationGroup'
import { tns } from "../node_modules/tiny-slider/src/tiny-slider.module.js"
// import Glide from '@glidejs/glide'

// import './js/fun/particles.min.js'
/*
new Vue({
	el: '#app',
	render: h=>h(App)
	// router,
})
//*/
/*
if(!window['YT']){
	const s = document.createElement("script");
	s.src = "https://www.youtube.com/iframe_api";
	const h = document.getElementsByTagName("head")[0];
	h.appendChild(s);
}
//*/

// particlesJS.load('particles', 'js/particlesjs-config.json')

menuMfn.init()
menuScroll.init()

const mobileWidth = 1040

const scrollWrap = document.querySelector('.scroll_wrap')
const moveWrap = document.querySelector('.move_wrap')
const sections = document.querySelectorAll('.section')
const setMainWrapWidth = function(){
	let moveWrap_w = 0
	Array.prototype.forEach.call(sections, section => {
		const w = section.clientWidth
		moveWrap_w += w
	})
	const wh = window.innerHeight
	moveWrap.setAttribute('width', `${moveWrap_w}px`)
	scrollWrap.setAttribute('height', `${wh}px`)
}


const cookieWrap = document.querySelector('#cookie_wrap')
const cookieClose = document.querySelector('#cookie_close')
cookieClose.addEventListener('click', function(){
	cookieWrap.classList.remove('active')
})


//*
const points = document.querySelector('.points')
const overlayPoints = document.querySelector('.overlay_points')
const pointsNext = document.querySelector('.points_next')
if(!!pointsNext){
	pointsNext.addEventListener('click', function(){
		if(this.className.search('points_next_hide') ==-1 ){
			this.classList.add('points_next_hide')
		}else{
			this.classList.remove('points_next_hide')
		}
	})
}
const pointsNextM = document.querySelectorAll('.points_next_m')
if(!!pointsNextM.length>0){
	Array.prototype.forEach.call(pointsNextM, btn => {
		btn.addEventListener('click', function(){
			overlayPoints.classList.add('active')
			document.body.classList.add('lock')
		})
	})
}
const pointsClose = document.querySelectorAll('.points_close')
if(!!pointsClose.length>0){
	Array.prototype.forEach.call(pointsClose, btn => {
		btn.addEventListener('click', function(){
			const dataM = this.getAttribute('data-m')
			if(dataM == 'true'){
				overlayPoints.classList.remove('active')
				document.body.classList.remove('lock')
				return
			}
			points.classList.remove('active')
			pointsNext.classList.remove('points_next_hide')
			window.noScroll = false
		})
	})
}
//*/


const inlinePic = document.querySelectorAll('.inline_pic')
if(inlinePic.length>0){
	Array.prototype.forEach.call(inlinePic, pic =>{
		const dtatPic = pic.getAttribute('data-pic')
		pic.setAttribute('style', dtatPic)
	})
}

// window.ytPlayer = {}
// const ytVideo = document.querySelectorAll('.yt_video')

/*
window.setPeopleBoxWidth = setPeopleBoxWidth
setPeopleBoxWidth.init()
*/

const ww = window.innerWidth
if(ww > mobileWidth){
	window.scrollHorizontal = scrollHorizontal

	/*
	const nextBtnWrap = document.querySelector(".next_btn_wrap")
  const nextBtns = nextBtnWrap.querySelectorAll(".next_btn")
	const prevBtnWrap = document.querySelector(".prev_btn_wrap")
  const prevBtns = prevBtnWrap.querySelectorAll(".prev_btn")

	Array.prototype.forEach.call(prevBtns, btn => {
		btn.addEventListener('click', function(){
			const id = btn.getAttribute('data-id')
			Array.prototype.forEach.call(menuItems, item => {
				const itemId = item.getAttribute('data-id')
				if(itemId !== id){
					item.classList.remove('active')
				}else{
					item.classList.add('active')
				}
			})
		})
	})
	Array.prototype.forEach.call(nextBtns, btn => {
		btn.addEventListener('click', function(){
			const id = btn.getAttribute('data-id')
			Array.prototype.forEach.call(menuItems, item => {
				const itemId = item.getAttribute('data-id')
				if(itemId !== id){
					item.classList.remove('active')
				}else{
					item.classList.add('active')
				}
			})
		})
	})
	//*/
}else{
	const menu = document.querySelector('#menu')
  const menuItems = menu.querySelectorAll('.sc_item')
  const nextBtnWrap = document.querySelector(".next_btn_wrap")
  const nextBtns = nextBtnWrap.querySelectorAll(".next_btn")
	const prevBtnWrap = document.querySelector(".prev_btn_wrap")
  const prevBtns = prevBtnWrap.querySelectorAll(".prev_btn")

	window.addEventListener('scroll', function(){
		Array.prototype.forEach.call(sections, (section, index) => {
			const wh = window.innerHeight
			const rect = section.getBoundingClientRect()
			const section_h = section.clientHeight
			if(rect.y<=wh*.7 && rect.y + section_h > wh*.3){
				section.classList.add('active')
				const activeItem = document.querySelector(`.menu_${section.id}`)
				activeItem.classList.add('active')
				// setPeopleBoxWidth.setWidth(index)
				Array.prototype.forEach.call(menuItems, item => {
					if(item !== activeItem){
						item.classList.remove('active')
					}
				})
				Array.prototype.forEach.call(prevBtns, btn => {
					const id = btn.getAttribute('data-show-id')
					if(id == section.id){
						btn.classList.add('active')
					}else{
						btn.classList.remove('active')
					}
				})
				Array.prototype.forEach.call(nextBtns, btn => {
					const id = btn.getAttribute('data-show-id')
					if(id == section.id){
						btn.classList.add('active')
					}else{
						btn.classList.remove('active')
					}
				})
				
				const countGroup = section.querySelectorAll('.count_group')
				if(!!countGroup){
					countAnimationGroup.count(countGroup)
				}
			}else{
				section.classList.remove('active')
				const countGroup = section.querySelectorAll('.count_group')
				if(!!countGroup){
					countAnimationGroup.reset(countGroup)
				}
			}
		})
	})
}

inViewport('view_item','trans', 0, scrollWrap)






/*
let t = 0
let tm = setInterval(()=>{
	t+=1
},1000)
//*/

// window.addEventListener('load', function(){
	/*
	clearInterval(tm)
	console.log(t)
	//*/

	if(ww > mobileWidth){
		setMainWrapWidth()
		scrollHorizontal.init(scrollWrap, moveWrap, 'auto')
	}

	const hash = window.location.hash.replace('#', '')

	/*
	Array.prototype.forEach.call(ytVideo, v=>{
		const ytId = v.getAttribute('data-yt-id')
		const playerId = v.getAttribute('data-player-id')
		const ytOverlayClose = v.querySelector('.yt_overlay_close')
		ytPlayerFn( 
			{
				ytid: ytId, 
				wrap: playerId, 
				width: '100%',
				height: '100%',
				vars: {
				},
				/*
				onReady: function(e) {
					const overlayHomeVideo = document.querySelector('.overlay_home_video')
					if(!!overlayHomeVideo && playerId == overlayHomeVideo.getAttribute('data-player-id') && overlayHomeVideo.className.search('trans')!==-1){
						setTimeout(function(){
		          console.log(e.target.getPlayerState())
							e.target.playVideo()
						},800)
					}
				},
				//*
			},
			function(tag){
				window.ytPlayer[playerId] = tag
			}
		)
		if(!!ytOverlayClose){
			ytOverlayClose.addEventListener('click', function(){
				window.ytPlayer[playerId].pauseVideo()
				overlayFn.close()
			})
		}
	})
	//*/
	
	/*
	if(!hash || hash == 'home' || !document.querySelector(`#${hash}`)) {
		overlayFn.open({box: 'overlay_home_video', inClose: 'true', noCover: 'true' })
		if(!!ytPlayer['homeVideo']){
			window.ytPlayer['homeVideo'].playVideo()
		}
	}
	//*/

	const menu = document.querySelector('#menu')
	const menuItems = menu.querySelectorAll('.sc_item')
	const prevBtns = document.querySelectorAll('.prev_btn')
	const nextBtns = document.querySelectorAll('.next_btn')
	Array.prototype.forEach.call(menuItems, (item, index) => {
		if(!!hash){
			if(hash == item.getAttribute('data-id')){
				item.classList.add('active')

				if(!!prevBtns[index-1]){
					prevBtns[index-1].classList.add('active')
				}
				if(!!nextBtns[index]){
					nextBtns[index].classList.add('active')
				}
				// if(ww > mobileWidth){
					const section = document.querySelector(`#${item.getAttribute('data-id')}`)
					section.scrollIntoView({ behavior: "smooth", block: "start"})
					const countGroup = section.querySelectorAll('.count_group')
					// console.log(countGroup)
					if(!!countGroup){
						countAnimationGroup.count(countGroup)
					}
					// console.log(document.querySelector(`#${item.getAttribute('data-id')}`))
				// }
				sections[index].classList.add('active')

				if(ww > mobileWidth){
					scrollHorizontal.isReset = true
				}
				
				// setPeopleBoxWidth.setWidth(index)
				
				if(ww > mobileWidth){
					setTimeout(function(){
						scrollHorizontal.resetPos()
					}, 1200)
				}
			}
		}else{
			// setPeopleBoxWidth.setWidth(0)
			menuItems[0].classList.add('active')
			sections[0].classList.add('active')
			nextBtns[0].classList.add('active')
		}
	})

	window.chronicleSliderTns = []
	const chronicleSliderWrap = document.querySelector('.chronicle_slider_wrap')
	// Array.prototype.forEach.call(chronicleSliderWrap, (csw, index) => {
		const chronicleSlider = chronicleSliderWrap.querySelector('.chronicle_slider')
		const chronicleSliderItems = chronicleSlider.querySelectorAll('.item')
		/*
		const sliderBtn = csw.querySelector('.chronicle_slider_btn_wrap')
		const sliderBtnPrev = sliderBtn.querySelector('.prev')
		const sliderBtnNext = sliderBtn.querySelector('.next')
		//*/

		// csw.setAttribute('data-id', index)
		const chronicleSliderItem_h = chronicleSliderItems[0].clientHeight
		// chronicleSlider.setAttribute('height', `${chronicleSliderItems.length*chronicleSliderItem_h}px`)

		/*
		const chronicleSliderTns = tns({
			container: chronicleSlider,
			mode: 'carousel',
			axis: "vertical",
			items: 1,
			slideBy: 1,
			center: true,
			autoplay: false,
			// controlsContainer: sliderBtn,
			controls: false,
			nav: false,
			autoHeight: true,
			autoplayHoverPause: false, 
			autoplayButtonOutput: false,
			autoplayTimeout: 3000,
			mouseDrag: false,
			touch: false,
			speed: 600,
			edgePadding: 0,
			loop: false,
			gutter: 0,
			rewind: false,
		})
		//*/

		// chronicleSliderTns.events.on('transitionEnd', function(info){
		// 	console.log(info.sheet)
		// })

		// window.chronicleSliderTns[index].events.on('transitionEnd', function(info){
		// 	const displayIndex = info.displayIndex
		// 	if(displayIndex == 1){
		// 		sliderBtnPrev.classList.remove('active')
		// 	}else if(displayIndex == sliderItems.length){
		// 		sliderBtnNext.classList.remove('active')
		// 	}
		// })

		// window.chronicleSliderTns[index].pause()
	// })

	const yearSliderWrap = document.querySelector('.year_slider_wrap')
	// const yearSliderBox = yearSliderWrap.querySelector('.slider_box')
	const yearSlider = yearSliderWrap.querySelector('.slider')
	const yearSliderItemsAll = yearSliderWrap.querySelectorAll('.year_item')
	const yearSliderItems = Array.from(yearSliderItemsAll).filter(sitem => !sitem.classList.contains('no_data'))
	// const yearSliderBtn = yearSliderWrap.querySelector('.year_slider_btn_wrap')
	const yearSliderItem_h = yearSliderItems[0].clientHeight
	// yearSliderWrap.setAttribute('height', `${yearSliderItem_h*3}`)
	// yearSlider.setAttribute('height', yearSliderItems.length*yearSliderItem_h)

	Array.prototype.forEach.call(yearSliderItems, item => {
		item.addEventListener('click', function(){
			const id = this.getAttribute('data-id')
			if(!id){
				return
			}

			chronicleSlider.setAttribute('data-active', id)
			yearSlider.setAttribute('data-active', id)
			Array.prototype.forEach.call(yearSliderItems, sitem => {
				sitem.classList.remove('active')
			})
			item.classList.add('active')
		})
	})

	/*
	const yearSliderTns = tns({
		container: yearSlider,
		mode: 'carousel',
		axis: "vertical",
		items: 3,
		slideBy: 1,
		center: false,
		autoplay: false,
		controlsContainer: yearSliderBtn,
		nav: false,
		// autoHeight: true,
		// autoplayHoverPause: false,
		// autoplayButtonOutput: false,
		// autoplayTimeout: 3000,
		mouseDrag: false,
		speed: 600,
		edgePadding: 0,
		loop: false,
		gutter: 0,
		rewind: false,
		responsive: {
			// 0: { axis: "horizontal" },
			// 481: { axis: "vertical" },
		}
	})
	
	yearSliderTns.events.on('transitionStart', function(info){
		Array.prototype.forEach.call(info.slideItems, item => {
			item.classList.remove('active')
		})
		const activeItems = yearSlider.querySelectorAll('.tns-slide-active')
		activeItems[0].classList.add('active')
		chronicleSliderTns.goTo(info.displayIndex-1)
	})
	Array.prototype.forEach.call(yearSliderItems, (item, index)=>{
		item.addEventListener('click', function(){
			if(item.className.search('no_data')==-1){
				yearSliderTns.goTo(index)
			}
		})
	})
	//*/


	const chronicle = document.querySelector('#chronicle')

	chronicle.addEventListener('wheel', function(e) {
    e.preventDefault()
		const dataActive = parseInt(chronicleSlider.getAttribute('data-active'))
    if(window.isChronicleScroll){
      return
    }
		window.isChronicleScroll = true
		let y = e.deltaY

		if(y>0){
			// yearSliderTns.goTo('next')
			if(dataActive+1<chronicleSliderItems.length){
				chronicleSlider.setAttribute('data-active', dataActive+1)
				yearSlider.setAttribute('data-active', dataActive+1)
				Array.prototype.forEach.call(yearSliderItems, (item, index) => {
					if(index == dataActive+1){
						item.classList.add('active')
					}else{
						item.classList.remove('active')
					}
				})
			}
			setTimeout(()=>{
				window.isChronicleScroll = false
			},1000)
    }else if(y<0){
			// yearSliderTns.goTo('prev')
			if(dataActive>0){
				chronicleSlider.setAttribute('data-active', dataActive-1)

				yearSlider.setAttribute('data-active', dataActive-1)
				Array.prototype.forEach.call(yearSliderItems, (item, index) => {
					if(index == dataActive-1){
						item.classList.add('active')
					}else{
						item.classList.remove('active')
					}
				})
			}
			setTimeout(()=>{
				window.isChronicleScroll = false
			},1000)
		}
	})
	
	const picSliderWrap = document.querySelectorAll('.pic_slider_wrap')
	Array.prototype.forEach.call(picSliderWrap, (psw, index) => {
		const slider = psw.querySelector('.pic_slider')
		const sliderItems = slider.querySelectorAll('.pic_item')
		const sliderBtn = psw.querySelector('.pic_slider_btn_wrap')

		if(sliderItems.length >1){
			new Glide(slider, {
				type: 'carousel',
				autoplay: 3000,
				gap: 0,
				preView: 1,
				hoverpause: false,
				animationDuration: 0,
				rewind: false,
			}).mount()
		}

		/*
		
		if(sliderItems.length <=1){
			sliderBtn.classList.add('hide')
		}

		const picSliderTns = tns({
			container: slider,
			mode: 'gallery',
			items: 1,
			slideBy: 1,
			center: true,
			autoplay: true,
			controlsContainer: sliderBtn,
			nav: false,
			autoHeight: true,
			autoplayHoverPause: false, 
			autoplayButtonOutput: false,
			autoplayTimeout: 3000,
			mouseDrag: true,
			speed: 600,
			edgePadding: 0,
			loop: true,
			gutter: 0,
			rewind: true,
		})
		//*/
	})


	const storySlider = document.querySelector('.story_slider')
	const sliderBtn = document.querySelector('.story_slider_btn_wrap')
	if(!!storySlider){
		new Glide(storySlider, {
			type: 'carousel',
			perView: 3,
			autoplay: false,
			gap: 15,
			hoverpause: false,
			animationDuration: 1000,
			rewind: true,
			breakpoints: {
				600: { perView: 2 },
			},
		}).mount()
	}
	/*
	const storySliderTns = tns({
		container: storySlider,
		mode: 'carousel',
		items: 3,
		slideBy: 1,
		center: false,
		autoplay: false,
		controlsContainer: sliderBtn,
		nav: false,
		autoHeight: true,
		autoplayHoverPause: false, 
		autoplayButtonOutput: false,
		mouseDrag: true,
		speed: 600,
		edgePadding: 0,
		loop: true,
		gutter: 15,
		rewind: true,
		responsive: {
			0: { items: 2 },
			601: { items: 3 },
		}
	})
	//*/

	//*
	const articleSliderWrap = document.querySelectorAll('.article_slider_wrap')
	Array.prototype.forEach.call(articleSliderWrap, asw => {
		const slider = asw.querySelector('.slider')
		const sliderItems = slider.querySelectorAll('.item')
		// const sliderBtn = asw.querySelector('.slider_btn_wrap')
		const dataOptions = slider.getAttribute('data-options')
		const options = { 
			type: 'carousel',
			perView: 3,
			autoplay: false,
			gap: 0,
			hoverpause: false,
			animationDuration: 1000,
			rewind: true,
			breakpoints: {
				1000: { perView: 2 },
				600: { perView: 1 },
			},
		}
		/*
		const options = { 
			container: slider,
			mode: 'carousel',
			// items: 3,
			slideBy: 1,
			center: false,
			autoplay: false,
			autoplayTimeout: 2000,
			// controls: false,
			controlsContainer: sliderBtn,
			nav: false,
			autoHeight: true,
			autoplayHoverPause: false, 
			autoplayButtonOutput: false,
			mouseDrag: true,
			speed: 600,
			edgePadding: 0,
			loop: true,
			gutter: 0,
			rewind: true,
			responsive: {
				0: { items: 1 },
				601: { items: 2 },
			}
		}
		//*/
		const optArr = {}
		if(!!dataOptions){
			const arr = dataOptions.split(',')
			arr.map(arr => {
				const a = arr.split(':')
				if(a[1]=='true'||a[1]=='false'){
					options[a[0]] = a[1]==='true'
					optArr[a[0]] = a[1]==='true'
				}else{
					options[a[0]] = a[1]
					optArr[a[0]] = a[1]
				}
			})
		}
		if(parseInt(optArr.perView) <= 2){
			options.breakpoints = {
				1000: { perView: 2 },
				600: { perView: 1 },
			}
		} else {
			options.breakpoints["1000"] = { perView: 2 }
		}
		if(parseInt(optArr.perView) >= 4){
			options.breakpoints["1200"] = { perView: 3 }
		}
		/*/
		if(parseInt(optArr.items) <= 2){
			options.responsive = {
				0: { items: 1 },
				601: { items: 2 },
			}
		} else {
			options.responsive["1001"] = { items: 3 }
		}
		if(parseInt(optArr.items) >= 4){
			options.responsive["1201"] = { items: 4 }
		}
		//*/

		// let items = options.items
		let perView = options.perView
		// const ww = window.innerWidth
		// if(ww>=0&&ww<601){
		// 	// items = 1
		// 	perView= 1
		// }else if(ww>=601&&ww<1001){
		// 	// items = 2
		// 	perView= 2
		// }else if(ww>=1001&&ww<1301){
		// 	// items = 3
		// 	perView= 3
		// }else {
		// 	// items = 4
		// 	perView= 4
		// }
		
		if(sliderItems.length < perView  && window.innerWidth > 600){
			// options.center = true
			asw.classList.add('no_slider')
			return
		}

		new Glide(slider, {
			type: 'carousel',
			perView: 3,
			autoplay: false,
			gap: 15,
			hoverpause: false,
			animationDuration: 1000,
			rewind: true,
			breakpoints: {
				1000: { perView: 2 },
				600: { perView: 1 },
			},
		}).mount()

		// const sliderTns = tns(options)
		// sliderTns.events.on('transitionEnd', function(info){
		// 	console.log(info)
		// });
		
		/*
		const articleSliderMenuItem = document.querySelectorAll(`.${asw.getAttribute('data-slider-menu')}`)
		if(articleSliderMenuItem.length > 0){
			Array.prototype.forEach.call(articleSliderMenuItem, (item, index) => {
				item.addEventListener('click', function(){
					Array.prototype.forEach.call(articleSliderMenuItem, a => {
						if(a == item) {
							a.classList.add('active')
						}else{
							a.classList.remove('active')
						}
					})
					const dataGroup = this.getAttribute('data-group')
					let goToIndex = index
					Array.prototype.forEach.call(sliderItems, (sItem, sIndex) => {
						const box = sItem.querySelector('.box')
						if(!!dataGroup && sItem.getAttribute('data-group') == dataGroup){
							goToIndex = sIndex
						}
						if(!box){
							return
						}
						if(index == sIndex) {
							box.classList.add('active')
						}else{
							box.classList.remove('active')
						}
					})
					sliderTns.goTo(goToIndex)
				})
			})
		}
		sliderTns.events.on('transitionEnd', function(info){
			if(articleSliderMenuItem.length > 0){
				let dataMenuActive = null
				Array.prototype.forEach.call(info.slideItems, item => {
					if(item.className.search('tns-slide-active')!==-1 && !!item.getAttribute('data-menu-active')){
						if(!dataMenuActive){
							dataMenuActive = parseInt(item.getAttribute('data-menu-active'))
						}
					}
				})
				// console.log(dataMenuActive)
				if(!!dataMenuActive){
					Array.prototype.forEach.call(articleSliderMenuItem, (item, index) => {
						if(dataMenuActive-1 == index){
							item.classList.add('active')
							return
						}
						item.classList.remove('active')
					})
				}
			}
		})
		//*/

		// ksTns.events.on('indexChanged', function(info){
		// 	console.log(info)
		// })
	})
	//*/

	tabFn.init()

	//*
	const forward = document.querySelector('#forward')
	const forwardSlider = document.querySelector('#forward_slider')

	const forwardSliderBtn = forward.querySelector('#forward_slider_btn_wrap')

	if(!!forwardSlider){
		new Glide(forwardSlider, {
			type: 'carousel',
			// type: 'slider',
			perView: 4,
			autoplay: false,
			// gap: 10,
			hoverpause: false,
			animationDuration: 1000,
			rewind: true,
			breakpoints: {
				1200: { perView: 3 },
				640: { perView: 2 },
				480: { perView: 1 },
			},
		}).mount()
	}
	/*
	const forwardOption = {
		container: forwardSlider,
		mode: 'carousel',
		// axis: "vertical",
		items: 4,
		slideBy: 1,
		center: false,
		autoplay: false,
		autoHeight: false,
		controlsContainer: forwardSliderBtn,
		nav: false,
		mouseDrag: false,
		speed: 600,
		edgePadding: 0,
		loop: true,
		gutter: 0,
		rewind: true,
		responsive: {
			0: {
				items: 1,
			},
			481: {
				items: 2,
			},
			641: {
				items: 3,
			},
			1201: {
				items: 4,
			}
		}
	}
	//*/

	
	const ytFrame = document.querySelector('#yt_frame')
	if(!!ytFrame){
		const frameSrc = "https://www.youtube.com/embed/"; 
		const ytFrameItem = document.querySelectorAll('.yt_frame_item')
		Array.prototype.forEach.call(ytFrameItem, item => {
			item.addEventListener('click', function(){
				const dataVideoId = this.getAttribute('data-video-id')
				ytFrame.setAttribute('src', frameSrc+dataVideoId)
			})
		})
		const defaultVideoId = ytFrameItem[0].getAttribute('data-video-id')
		ytFrame.setAttribute('src', frameSrc+defaultVideoId)
	}


	/*
	if(window.innerWidth <= 800){
		forwardOption.axis = 'horizontal'
	}

	const forwardSliderTns = tns(forwardOption)
	//*/
	 
	const sloganSilder = document.querySelector('#slogan_silder')
	if(!!sloganSilder) {
		let sloganActive = 0;
		const sloganSilderItem = sloganSilder.querySelectorAll('.item')
		sloganSilderItem[sloganActive].classList.add('active')
		setInterval(function(){
			if(sloganActive+1==sloganSilderItem.length){
				sloganActive = 0
			}else{
				sloganActive += 1
			}
			Array.prototype.forEach.call(sloganSilderItem, (item, index) => {
				item.classList.remove('active')
			})
			sloganSilderItem[sloganActive].classList.add('active')
		},3000)
	}
	/*
	const sloganSliderTns = tns({
		container: sloganSilder,
		mode: 'gallery',
		items: 1,
		slideBy: 1,
		center: true,
		autoplay: true,
		// controlsContainer: sliderBtn,
		controls: false,
		nav: false,
		autoHeight: true,
		autoplayHoverPause: false, 
		autoplayButtonOutput: false,
		autoplayTimeout: 3000,
		mouseDrag: false,
		speed: 500,
		edgePadding: 0,
		loop: true,
		gutter: 0,
		rewind: false,
	})
	//*/
	
// })

let resizeTimer = null
window.addEventListener('resize', function(){
	const ww = window.innerWidth
	clearTimeout(resizeTimer)
	resizeTimer = this.setTimeout(function(){
		if(ww > mobileWidth){
			setMainWrapWidth()
		}
		
		// setPeopleBoxWidth.resize()

		if(ww > mobileWidth){
			scrollHorizontal.isReset = true
			setTimeout(function(){
				scrollHorizontal.resetPos()
			}, 700)
		}
	},100)
})

moveWrap.getBoundingClientRect


overlayFn.init()
